/** Small hooks that keep props stable so memoized widgets skip renders. */
import { useCallback, useRef } from 'react';

/** A function whose identity never changes and that always calls the latest `fn`. */
export function useStableCallback<A extends unknown[], R>(fn: (...args: A) => R): (...args: A) => R {
  const ref = useRef(fn);
  ref.current = fn;
  return useCallback((...args: A) => ref.current(...args), []);
}

/** The previous array while its items are the same (by identity), so memos keyed on it hold. */
export function useStableArray<T>(next: T[]): T[] {
  const ref = useRef(next);
  const prev = ref.current;
  if (prev !== next && (prev.length !== next.length || prev.some((v, i) => v !== next[i]))) ref.current = next;
  return ref.current;
}
